module.exports = __webpack_public_path__ + "img/VectorByte-logo-4k.42ea9db2.png";